module.exports = __webpack_public_path__ + "media/images/lb/399-1af6391fb42632b613fe22c95d428a92.svg";